const actionTypeIdentifier = '3192CA66-7F78-47ED-AB21-2AE5995F055A';

export const getInvoiceDetailsComments = `GET-INVOICE-DETAILS-COMMENTS${actionTypeIdentifier}`;
export const setInvoiceDetailsError = `SET-INVOICE-DETAILS-ERROR${actionTypeIdentifier}`;
export const resetInvoiceComments = `RESET-INVOICE-DETAILS-COMMENTS${actionTypeIdentifier}`;
export const insertInvoiceDetailsComments = `INSERT-INVOICE-DETAILS-COMMENTS${actionTypeIdentifier}`;
